<template>
  <div>
    <ts-table :columns="columns" :records="componentLists" :expandable="true">
      <template v-slot="{ record }">
        <td>{{ record.comp_item_name }}</td>
        <td>{{ record.display_order }}</td>
      </template>
      <div slot="expand" slot-scope="prop">
        <ul class="nav nav-inbox">
          <li
            class="mr-2"
            v-for="(component, index) in prop.record.component_items"
            :key="index"
          >
            <span class="badge badge-primary pull-left mr-2">
              {{ index + 1 }}
            </span>
            <strong>{{ component.subject_comp_item_detail_name }}</strong>
          </li>
        </ul>
      </div>
    </ts-table>
  </div>
</template>

<script>
export default {
  name: 'tableExpand',
  props: ['componentLists'],
  data () {
    return {}
  },
  computed: {
    columns () {
      return [
        {
          name: 'Assessment Component Name'
        },
        {
          name: 'Display Order'
        }
      ]
    }
  }
}
</script>
